import React from "react";
import PropTypes from "prop-types";
import { injectIntl, FormattedMessage } from "react-intl";
import styles from "./styles/table.css.js";
import withStyles from "components/with-styles";
import CopyToClipboard from "components/copy-to-clipboard";
import TableRow from "@material-ui/core/TableRow";
import { HeaderCell } from "components/table";
import TableCell from "@material-ui/core/TableCell";
import { PaginatedTable } from "components/table";
import FormConfirm from "components/form/form-confirm";
import { useImperativeTracking } from "components/tracking";

const Header = () => (
  <TableRow>
    <HeaderCell>
      <FormattedMessage id="event.fonts.table.name" />
    </HeaderCell>
    <HeaderCell>
      <FormattedMessage id="event.fonts.table.src" />
    </HeaderCell>
  </TableRow>
);

const RowComponent = ({ item, classes }) => {
  const track = useImperativeTracking();

  const handleClick = () => {
    track(`user copies font [${item.id}] with name [${item.name}] and insert url [${item.url}]`);
  };

  return (
    <TableRow key={item.id}>
      <TableCell>{item.name}</TableCell>
      <TableCell>
        <CopyToClipboard textToCopy={item.url} onClick={handleClick} />
      </TableCell>
    </TableRow>
  );
};

RowComponent.propTypes = {
  /**
   ** Elemento a representar en la fila de la tabla
   **/
  item: PropTypes.object,
};

const I18nStyledRowComponent = withStyles(styles)(RowComponent);

const InsertUrlsTable = ({ classes, event, intl, isCamera = false, ...props }) => {
  const fonts = event && event.infoBert && event.infoBert.remoteIngestions ? event.infoBert.remoteIngestions : [];
  const filteredFonts = fonts.filter(({ type }) => type === (isCamera ? "VIDEO+AUDIO" : "AUDIO-ONLY"));

  return filteredFonts && filteredFonts.length > 0 ? (
    <PaginatedTable
      className={classes.table}
      paginatedElements={{ items: filteredFonts, total: filteredFonts.length }}
      headerComponent={Header}
      rowComponent={I18nStyledRowComponent}
      showPagination={false}
      perPage={0}
    />
  ) : (
    <FormConfirm
      show
      label={intl.formatMessage({ id: isCamera ? "event.fonts.table.empty.video" : "event.fonts.table.empty.audio" })}
      warning
      className={classes.warning}
      hideCloseButton
    />
  );
};

InsertUrlsTable.propTypes = {
  /**
   * Evento
   */
  event: PropTypes.object,
  /**
   * Indica si es cámara o audio
   */
  isCamera: PropTypes.bool,
};

export default injectIntl(withStyles(styles)(InsertUrlsTable));
